import Events from 'events';
import Constants from './../Constants';

export default class PopupStore extends Events.EventEmitter {

  constructor() {
    super();
    this._people = [];
    this._index = 0;
  }

  populate(people) {
    this._people = people;
    this._emitPopulatePopup();
  }

  open(index) {
    this._index = index;
    this._emitUpdatePerson();
    this._emitOpenPopup();
  }

  close() {
    this._index = 0;
    this._emitClosePopup();
  }

  navigateRight() {
    if ((this._index + 1) >= this._people.length) {
      throw new Error(`Cannot navigate beyond the final person (${this._people.length} users, at index ${this._index}).`);
    }

    this._index++;

    this._emitUpdatePerson();
  }

  navigateLeft() {
    if ((this._index - 1) < 0) {
      throw new Error(`Cannot navigate to before the first person (${this._people.length} users, at index ${this._index}).`);
    }

    this._index--;

    this._emitUpdatePerson();
  }

  getCurrentPerson() {
    return this._people[this._index];
  }

  getCurrentPeople() {
    return this._people;
  }

  canNavigateLeft() {
    return this._index > 0;
  }

  canNavigateRight() {
    return this._index < (this._people.length - 1);
  }

  addPopulateListener(callback) {
    this.on(Constants.EVENT_POPULATE_POPUP, callback);
  }

  addOpenListener(callback) {
    this.on(Constants.EVENT_OPEN_POPUP, callback);
  }

  addUpdateListener(callback) {
    this.on(Constants.EVENT_UPDATE_PERSON, callback);
  }

  addCloseListener(callback) {
    this.on(Constants.EVENT_CLOSE_POPUP, callback);
  }

  _emitPopulatePopup() {
    this.emit(Constants.EVENT_POPULATE_POPUP);
  }

  _emitOpenPopup() {
    this.emit(Constants.EVENT_OPEN_POPUP);
  }

  _emitUpdatePerson() {
    this.emit(Constants.EVENT_UPDATE_PERSON);
  }

  _emitClosePopup() {
    this.emit(Constants.EVENT_CLOSE_POPUP);
  }

}
